// extracted by mini-css-extract-plugin
export default {"preRelease":"PreRelease_preRelease__9NYua","QrCode":"PreRelease_QrCode__PXTBo"};